import Locale from 'src/Locale';
import Routes from 'src/services/Routes';

export const USER_SEARCH_TYPE = {
    EMAIL: 'email',
    NAME: 'name',
    USER_ID: 'userId',
};

/** One-time Home → Users navigation uses legacy (no searchType) API inference. */
export const USERS_LEGACY_SEARCH_HANDOFF_KEY = [Routes.USERS.id, 'legacySearchHandoff'];

/**
 * Home handoff results mode: hides the search-type dropdown and keeps list loads on the
 * legacy API path (no searchType) until the user clears or runs a typed search.
 */
export const USERS_LEGACY_HANDOFF_HIDE_SEARCH_TYPE_KEY = [Routes.USERS.id, 'legacyHandoffHideSearchType'];

const NAME_PATTERN = /^[a-zA-Z0-9+_\-.@\s]+$/;
const USER_ID_PATTERN = /^[0-9][a-zA-Z0-9]+$/;
export const trimSearchValue = value => (value || '').trim();

/**
 * @returns {object|null} react-intl message descriptor from Locale, or null if valid
 */
export const validateUserSearchByType = (searchValue, searchType) => {
    const search = trimSearchValue(searchValue);
    if (!search) {
        return Locale.user_search_required;
    }

    switch (searchType) {
        case USER_SEARCH_TYPE.NAME:
            if (search.length < 3) {
                return Locale.user_search_min_length;
            }
            if (!NAME_PATTERN.test(search)) {
                return Locale.user_search_invalid_name;
            }
            return null;
        case USER_SEARCH_TYPE.EMAIL:
            // Same charset rules as legacy partner-tab search (prefix / partial email allowed).
            if (search.length < 3) {
                return Locale.user_search_min_length;
            }
            if (!NAME_PATTERN.test(search)) {
                return Locale.user_search_invalid_email;
            }
            return null;
        case USER_SEARCH_TYPE.USER_ID:
            if (!USER_ID_PATTERN.test(search)) {
                return Locale.user_search_invalid_user_id;
            }
            return null;
        default:
            return Locale.user_search_required;
    }
};

export const formatUserSearchValidationError = (messageDescriptor, formatMessage) =>
    messageDescriptor ? formatMessage(messageDescriptor) : null;
